/**
 * @file Derives the state of residence to show for an investor's residency profile.
 */
import type { ResidencyProfile } from "../types";

const LABEL_NOT_US_RESIDENT = "Not a resident of US";

/**
 * Resolves the state of residence to show for a profile, or a not-a-US-resident label.
 */
const getUsResidenceState = (
  isEntity: boolean,
  profile: ResidencyProfile,
  addressState?: string,
): string | undefined => {
  const {
    isUsPerson,
    isUsCitizen,
    residenceState,
    hasOtherUsResidenceState,
  } = profile;

  const computedResidenceState = hasOtherUsResidenceState
    ? residenceState
    : addressState;

  if (isEntity) {
    return computedResidenceState;
  }

  if (isUsCitizen) {
    return computedResidenceState;
  }

  if (!isUsPerson) {
    return LABEL_NOT_US_RESIDENT;
  }

  return computedResidenceState;
};

export default getUsResidenceState;
